export default class Account {


  constructor (ref) {
      this.id = ref.id || ''
      this.sum_balance = ref.sum_balance || 0
      this.sum_locked = ref.sum_locked || 0
      this.sum_invested = ref.sum_invested || 0
      this.profit = ref.profit || 0
      this.num = ref.num || ''
 //     this.transactions = ref.transactions || []
 //     this.investments = ref.investments || []
  }

}



// WEBPACK FOOTER //
// ./src/models/Account.js